import React from 'react';

// material ui
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';

import FilterItem from './filteritem';

export default class Filters extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showFilters: false,
      filters: this.props.filters,
      uuids: this.props.allUUIDs,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.allUUIDs !== this.state.uuids) {
      this.setState({uuids:prevProps.allUUIDs});
    }
  }

  _addFilter() {
    var filterArray = this.state.filters;
    filterArray.push({ key: '', value: '' });
    this.setState({ filters: filterArray });
  }

  _updateFilters(filter) {
    const filters = filter && filter.value ? [{'key': 'id', 'value': filter.value.uuid, 'dev_id': filter.value.dev_id}] : [];
    this.setState({filters});
    this.props.onFilterChange(filters);
  }  

  // _updateFilters(filter, index) {
  //   let filters = this.state.filters;
  //   var filters_all = JSON.parse( JSON.stringify( this.state.filters ) );
  //   var original_filter = JSON.parse( JSON.stringify( filter ) );
  //   let map = filter.value;
  //   let filter_uuid = filter;

  //   filter_uuid.value = (map && map.uuid) || '';
  //   filters[index] = filter_uuid;
    
  //   this.setState({ filters });
    
  //   filters_all[index] = JSON.parse( JSON.stringify(original_filter ) );
  //   this.props.onFilterChange(filters_all);
  // }

  _removeFilter(index) {
    var filterArray = this.state.filters;
    filterArray.splice(index, 1);
    this.setState({ filters: filterArray }, this.props.onFilterChange(filterArray));
  }
  _toggleNav() {
    this.setState({
      showFilters: !this.state.showFilters
    });
  }
  _clearFilters() {
    if (this.state.filters.length) {
      this.setState({ filters: [] }, this.props.onFilterChange([]));
    }
  }
  render() {
    const self = this;
    const filters = self.state.filters.length ? self.state.filters : [{ key: '', value: '' }];
    var filterCount = 0;
    const filterAttributes = Object.entries(self.props.attributes).map(item => ({ key: item[0], value: item[1] }));
    
    const remainingFilters = filterAttributes.reduce((accu, item) => {
      const isInUse = filters.find(filter => filter.key === item.key);
      if (isInUse) {
        filterCount = filterCount + 1;
      } else {
        accu.push(item);
      }
      return accu;
    }, []);

    const filterItems = filters.map((item, index) => (
      <FilterItem
        key={self.state.filters.length ? index : `refresh-${index}`}
        index={index}
        filter={item}
        filters={remainingFilters}
        filterAttributes={filterAttributes}
        attributeValues={self.state.uuids}
        onRemove={() => self._removeFilter(index)}
        onSelect={filter => self._updateFilters(filter, index)}
      />
    ));

    const canAddMore = remainingFilters.length && filterCount;
    const drawerStyles = this.state.showFilters ? { overflow: 'visible', top: '57px' } : { overflow: 'hidden', top: '57px' };
    return (
      <div style={{ position: 'relative' }}>
        <Button style={{ position: 'absolute', top: 0, right: 0, zIndex: 100 }} color="secondary" onClick={() => self.setState({ showFilters: true })}>
          <FilterListIcon className="buttonLabelIcon" />
          {filterCount > 0 ? `Filters (${filterCount})` : 'Filters'}
        </Button>
        <Drawer
          open={this.state.showFilters}
          docked="false"
          anchor="right"
          opensecondary="true"
          PaperProps={{ style: { width: 400, padding: 20, ...drawerStyles } }}
          BackdropProps={{ style: drawerStyles }}
          onClose={() => self.setState({ showFilters: false })}
        >
          <IconButton
            className="closeSlider"
            onClick={() => self.setState({ showFilters: false })}
            style={{ position: 'absolute', left: '-25px', background: 'white', top: '20px' }}
          >
            <CloseIcon />
          </IconButton>
          <div className="align-right margin-top-small">
            <a onClick={() => this._clearFilters()}>Clear all filters</a>
          </div>
          <List>{filterItems}</List>
          {this.props.isHosted ? (
            <Button variant="text" disabled={!canAddMore} onClick={() => this._addFilter()} color="secondary">
              <AddCircleIcon className="buttonLabelIcon" />
              Add filter
            </Button>
          ) : null}
        </Drawer>
      </div>
    );
  }
}
